import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
import { Col, Row, Tabs, Spin } from "antd";
import { getStyleProperties } from "../../utils/CustomFunc";
import DateBasedLine from "./Graph/LineChart";
import PerformanceTrend from "./Graph/PerformanceTrend";
import DownTimePieGraph from "./Graph/DownTimePieGraph";
import DownTimeBarGraph from "./Graph/DownTimeBarGraph";
import OutputTrend from "./Graph/OutputTrend";
import SOP from "./Tables/SOP";
import Plan from "./Tables/Plan";
import Andon from "./Andon/AndonPage";
import HotLine from "./HotLine";
import { LoadingOutlined } from "@ant-design/icons";
import { deepEqual } from "../../utils/CustomFunc";
import RightIconContainer from "./RightIcons";
import liracrypt from "../../components/Liracrypt/liracrypt";
import SessionError from "../../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../../components/ApiErrorComp/ApiErrorComp";
import LineDashReport from "./LineDashReport";
import LineDashPlanning from "./LineDashPlanning";
import OnlineLineReport from "../../components/Reports/OnlineDefectEntryTab";
import LineDashTab from "./LineDashTab";

const { TabPane } = Tabs;

const LineDashAndroid = (props) => {
  const [loginError, setLoginError] = useState(false);

  const [rightContainer, setRightContainer] = useState(null);
  const [selectedTab, setSelectedTab] = useState(
    window.location.pathname === "/linedashtab" ? "Main" : "PerformanceTrend"
  );
  const [addonLoaded, setAddonLoaded] = useState(false);
  const [andonstatus, setAndonstatus] = useState(null);
  const [state, setState] = useState(null);

  const [andonBlock, setAndonBlock] = useState(null);

  // const [andonstatusLoaded, setAndonstatusLoaded] = useState(false);
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;

  const RightIconHolder = () => {
    return (
      <RightIconContainer
        selectedLid={props.selectedLid}
        andonstatus={andonstatus}
        addonLoaded={addonLoaded}
        rightContainer={rightContainer}
        compliance={props.compliance}
      />
    );
  };

  const fetchBom = () => {
    liracrypt
      .get("/bom", {})
      .then(({ data }) => {
        localStorage.setItem("bom", JSON.stringify(data.data));
        fetchMachine();
      })
      .catch(function (error) {
        console.log("Error****: Unable to fecth BOM");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };
  const fetchMachine = () => {
    liracrypt
      .get("/mdict", { typ: "Machine", subTyp: "idame" })
      .then(({ data }) => {
        const keys = Object.keys(data.data);
        const newData = keys.map((key) => {
          return { _id: key, Name: data.data[key] };
        });
        localStorage.setItem("machine", JSON.stringify(newData));
        fetchTool();
      })
      .catch(function (error) {
        console.log("Error****: Unable to fecth Machine");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  // const RightIconContainerRef = () => {
  //   return (

  //   );
  // };

  const fetchTool = () => {
    liracrypt
      .get("/mdict", { typ: "Tool", subTyp: "idame" })
      .then(({ data }) => {
        const keys = Object.keys(data.data);
        const newData = keys.map((key) => {
          return { _id: key, Name: data.data[key] };
        });
        localStorage.setItem("tool", JSON.stringify(newData));
        fetchAndonDetail();
      })
      .catch(function (error) {
        console.log("Error****: Unable to fecth TOOL");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const fetchAndonDetail = () => {
    liracrypt
      .get("/linedashboard/andonstatus", { lid: props.selectedLid })
      .then(({ data }) => {
        
        if (!andonstatus) {
          setAndonstatus(data.data);
          setAndonBlock(data.data.escDetails);
        } else {
          if (!deepEqual(andonstatus, data)) {
            setAndonstatus(data.data);
          }
        }
        setAddonLoaded(true);
      })
      .catch(function (error) {
        console.log("Error****:", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const handleAndonStatus = (updated) => {
    setAddonLoaded(false);
    if (updated === true) {
      fetchAndonDetail();
    } else {
      setAddonLoaded(true);
    }
  };

  useEffect(() => {
    if (
      !localStorage.getItem("bom") ||
      !localStorage.getItem("machine") ||
      !localStorage.getItem("tool")
    ) {
    //  fetchBom();
    } else {
      fetchAndonDetail();
    }

    // setInterval(() => {
    if (rightContainer === null) {
      let dataBlock = [];
      for (let i = 0; i < props.settings.ld_main.dataBlocks; i++) {
        const key =
          i < 10 ? "ld_DataBlock_0" + (i + 1) : "ld_DataBlock_" + (i + 1);
        const settingKey =
          i < 10 ? "lD_DataBlock_0" + (i + 1) : "lD_DataBlock_" + (i + 1);
        if (props.settings.hasOwnProperty(key)) {
          dataBlock.push({
            text: props.settings[key].text,
            text_style: getStyleProperties(props.settings[key].legend),
            value: props.settingValues[settingKey],
            value_style: getStyleProperties(props.settings[key].data),
            numbeOfBlock: props.settings.ld_main.dataBlocks,
            backgroundColor: props.settings[key]["background-color"],
            width: 80 / props.settings.ld_main.dataBlocks + "%",
          });
        }
      }
      setRightContainer({
        dataBlock: dataBlock,
        andon: props.settings.ld_Andon,
        tabs: props.settings.ld_Tab_Main,
      });
    }
    // }, 10000);
  }, [props]);

  useEffect(() => {
    Promise.all([
      liracrypt.get("/linedash/linedashuiconfig", {}),
      liracrypt.get("/linedash/linedashvariabledata", {
        lid: props.selectedLid,
        proj: "all",
      }),
      liracrypt.get("/linedash/linedashfixeddata", {
        lid: props.selectedLid,
      }),
      liracrypt.get("/linedash/linedashvariabledata", {
        lid: props.selectedLid,
        proj: "compliance",
      }),
    ]).then(([lineDashLoad, lineDashValues, lineDetails, compliance]) => {
      setState({
        ...state,
        settings: lineDashLoad.data.data,
        settingValues: lineDashValues.data.data,
        lineDetails: lineDetails.data.config,
        compliance: compliance.data.data["compliance"],
        loaded: true,
      });
    });
  }, []);

  const getTabsPannel = (tab) => {
    const tabCap = tab;
    // const tabCap = tab.toUpperCase();
    // const tabCap = tab.toUpperCase()
    // console.log(tab, tabCap);
    switch (tabCap) {
      case "Main":
        // console.log(rightContainer);
        return (
          <>
            <SessionError visible={loginError} />
            <LineDashTab selectedLid={props.selectedLid} />
          </>
        );
      case "PerformanceTrend":
        return (
          <>
            <SessionError visible={loginError} />
            <div>
              <PerformanceTrend selectedLid={props.selectedLid} />
            </div>
          </>
        );
      case "Downtime":
        return (
          <>
            <SessionError visible={loginError} />
            <Row gutter={12}>
              <Col span={12}>
                <DownTimePieGraph selectedLid={props.selectedLid} />
              </Col>
              <Col span={12}>
                <DownTimeBarGraph selectedLid={props.selectedLid} />
              </Col>
            </Row>
          </>
        );
      case "SOP":
        return (
          <>
            <SessionError visible={loginError} />
            <div>
              <SOP selectedLid={props.selectedLid} />
            </div>
          </>
        );
      case "OutputTrend":
        return (
          <>
            <SessionError visible={loginError} />
            <div>
              <OutputTrend selectedLid={props.selectedLid} />
            </div>
          </>
        );
      case "PLAN1":
      case "Planning":
        return (
          <>
            <SessionError visible={loginError} />
            <div>
              {/* <Plan selectedLid={props.selectedLid} /> */}
              <LineDashPlanning lid={props.selectedLid} />
            </div>
          </>
        );
      case "Hotline":
        return (
          <>
            <SessionError visible={loginError} />
            <div style={{ padding: "40px 10px" }}>
              <HotLine selectedLid={props.selectedLid} />
            </div>
          </>
        );
      // case "QUALITY":
      case "Reports":
        return (
          <>
            <SessionError visible={loginError} />
            <div>
              <LineDashReport lid={props.selectedLid} />
            </div>
          </>
        );
      //     break;
      case "Andon":
        return addonLoaded ? (
          <>
            <SessionError visible={loginError} />
            <Andon
              settingValues={props.settingValues}
              andonstatus={andonstatus}
              handleAndonStatusCallback={handleAndonStatus}
              selectedLid={props.selectedLid}
              andonBlock={andonBlock}
              lid={props.selectedLid}
            />
          </>
        ) : (
          <>
            <SessionError visible={loginError} />
            <div className="Loading">
              <Spin indicator={antIcon} />
            </div>
          </>
        );
      // case "OTHERS":

      case "Quality":
        return (
          <>
            <OnlineLineReport
              setPageHeader={() => {}}
              marginLeft={"145px"}
              fetchAndonDetail={fetchAndonDetail}
              lid={props.selectedLid}
            />
          </>
        );

      //     break;
      default:
        return (
          <>
            <SessionError visible={loginError} />
            <div>
              <DateBasedLine selectedLid={props.selectedLid} />
            </div>
          </>
        );
    }
  };

  return (
    <>
      <SessionError visible={loginError} />
      <React.Fragment>
        {rightContainer !== null ? (
          <Row className="RightContainer" justify={"center"}>
            <Col style={{ padding: "5px" }}>
              <Row gutter={24}>
                <Col
                  span={22}
                  style={{ padding: "10px 0 0", marginTop: "10px" }}
                >
                  <div
                    className="TabsPanel borderBox"
                    style={{
                      padding: "20px",
                      overflow: "hidden",

                      backgroundColor: rightContainer.tabs["background-color"],
                      height: "577px",
                      borderRadius: "10px",
                      width: "90%",
                      marginLeft: "100px",
                      border: 0,

                      boxShadow: "5px 5px 9px #171717,-5px -5px 9px #232323",
                      // boxShadow: "4px 9px 26px 0px rgba(0,0,0,0.54)",
                    }}
                  >
                    <Tabs
                      defaultActiveKey={selectedTab}
                      className="android"
                      type="card"
                      tabPosition={"top"}
                      tabBarStyle={{
                        border: 0,
                        height: "40px",
                        marginBottom: "5px",
                      }}
                      onChange={(activeKey) => setSelectedTab(activeKey)}
                    >
                      {window.location.pathname === "/linedashtab" ? (
                        <TabPane tab={"Main"} key={"Main"}></TabPane>
                      ) : (
                        <></>
                      )}
                      <>
                        {rightContainer.tabs.text.map((tab, i) => (
                          <TabPane tab={tab} key={tab}></TabPane>
                        ))}
                      </>
                    </Tabs>
                    <div
                      style={{
                        paddingTop: "-5px",
                      }}
                    >
                      {getTabsPannel(selectedTab)}
                    </div>
                  </div>
                </Col>
                <Col
                  span={2}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <RightIconContainer
                    selectedLid={props.selectedLid}
                    andonstatus={andonstatus}
                    addonLoaded={addonLoaded}
                    rightContainer={rightContainer}
                    compliance={props.compliance}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        ) : null}
      </React.Fragment>
    </>
  );
};
export default LineDashAndroid;
